import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function createPasswordStrengthValidator(control: AbstractControl, email: string): ValidationErrors | null {
  const value = control.value;

  const hasUpperCase = /[A-Z]+/.test(value);

  const hasLowerCase = /[a-z]+/.test(value);

  const hasNumeric = /[0-9]+/.test(value);

  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);

  const requiredLength = value.length >= 8;

  let notEmail = true;
  if (email) {
    const lowerEmail = email.toLowerCase();
    const lowerPassword = value.toLowerCase();
    const username = email.split('@')[0];

    notEmail = !lowerPassword.includes(lowerEmail) && lowerPassword !== username.toLowerCase();
  }

  const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar && requiredLength && notEmail;
  let existingErrors = control.errors;

  // Reset incorrect value from existingErrors
  if (existingErrors) {
    delete existingErrors.hasUpperCase;
    delete existingErrors.hasLowerCase;
    delete existingErrors.hasNumeric;
    delete existingErrors.requiredLength;
    delete existingErrors.hasSpecialChar;
    delete existingErrors.notEmail;
  }

  if (existingErrors && Object.keys(existingErrors).length === 0) {
    existingErrors = null;
  }

  // Add incorrect: true if necessary, or else keep the old errors
  const newErrors = !passwordValid
    ? {
      ...existingErrors,
      hasUpperCase: !hasUpperCase,
      hasLowerCase: !hasLowerCase,
      hasNumeric: !hasNumeric,
      hasSpecialChar: !hasSpecialChar,
      requiredLength: !requiredLength,
      notEmail: !notEmail
    }
    : existingErrors;
  control.setErrors(newErrors);
  return !passwordValid ? newErrors : null;
}

export function confirmPassword(passwordProperty: string, confirmPasswordProperty: string): ValidatorFn {
  return (form: any): ValidationErrors | null => {
    const passwordValue = (form.controls[passwordProperty].value) || 0;
    const confirmPasswordValue = (form.controls[confirmPasswordProperty].value) || 0;
    let existingPasswordErrors = form.controls[passwordProperty].errors;
    let existingConfirmPasswordErrors = form.controls[confirmPasswordProperty].errors;
    const check = passwordValue !== confirmPasswordValue;

    // Reset incorrect value from existingErrors
    if (existingPasswordErrors) {
      delete existingPasswordErrors.missMatch;
    }
    if (existingConfirmPasswordErrors) {
      delete existingConfirmPasswordErrors.missMatch;
    }

    // If there are no errors, we need "null" instead of empty object "{}", so it becomes value
    if (existingPasswordErrors && Object.keys(existingPasswordErrors).length === 0) {
      existingPasswordErrors = null;
    }
    if (existingConfirmPasswordErrors && Object.keys(existingConfirmPasswordErrors).length === 0) {
      existingConfirmPasswordErrors = null;
    }

    // Add incorrect: true if necessary, or else keep the old errors
    const newPasswordErrors = check
      ? {...existingPasswordErrors, missMatch: true}
      : existingPasswordErrors;
    const newConfirmPasswordErrors = check
      ? {...existingConfirmPasswordErrors, missMatch: true}
      : existingConfirmPasswordErrors;
    // Set eventual errors
    form.controls[passwordProperty].setErrors(newPasswordErrors);
    form.controls[confirmPasswordProperty].setErrors(newConfirmPasswordErrors);

    return check ? newConfirmPasswordErrors : null;
  };
}

export function verifyIfCnpIsDiff(cnpProperty: string): ValidatorFn{
  return(control: AbstractControl): ValidationErrors | null =>{
    if(control.value === cnpProperty){

      return { errors: true};
    }
    return null;

  };
}

export function emailOrNumericIdValidator(
  emailPattern: RegExp,
  idPattern: RegExp
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const isEmail = emailPattern.test(value);
    const isId = idPattern.test(value);

    return isEmail || isId ? null : { emailOrId: true };
  };
}
